<h1 mat-dialog-title>Delete {{ item.type }}?</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete {{ item.name }}?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No thanks</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes, delete</button>
</div>
